import React from 'react';
import { Modifier, EditorState } from 'draft-js';
import { Tooltip } from 'antd';

import { textMap } from './constants';
import TagComponent from './component';

const style = {
  color: '#fff',
  backgroundColor: 'rgb(16, 142, 233)',
  display: 'inline-flex',
  padding: '2px 20px 2px 8px',
  borderRadius: '4px',
  maxWidth: '170px',
  margin: '2px 5px'
};
const styleTextOverflow = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};

const insertTag = (editor, editorState, data) => {
  const { label, text } = data;

  const contentState = editorState.getCurrentContent();

  const contentStateWithEntity = contentState.createEntity('TAG', 'IMMUTABLE', { selectType: label, text });
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  const currentSelectionState = editorState.getSelection();
  let addedContent;
  let emojiEndPos = 0;
  let blockSize = 0;
  let afterRemovalContentState = Modifier.removeRange(contentState, currentSelectionState, 'backward');
  afterRemovalContentState = Modifier.removeRange(contentState, currentSelectionState, 'backward');

  const targetSelection = afterRemovalContentState.getSelectionAfter();
  addedContent = Modifier.insertText(
    afterRemovalContentState,
    targetSelection,
    `{{${label}|'${text}'}}`,
    null,
    entityKey
  );

  emojiEndPos = targetSelection.getAnchorOffset();
  const blockKey = targetSelection.getAnchorKey();
  blockSize = contentState.getBlockForKey(blockKey).getLength();

  if (emojiEndPos === blockSize) {
    addedContent = Modifier.insertText(addedContent, addedContent.getSelectionAfter(), ' ');
  }

  const newState = EditorState.push(editorState, addedContent, 'insert-tag');
  editor.setValue(newState);
};
export default options => {
  options = {
    ...options
  };

  const { includeEditors } = options;

  return {
    key: 'tag',
    type: 'entity',
    name: 'TAG',
    // https://github.com/margox/braft-editor/issues/708
    // 有这个属性不会执行importer和exporter
    includeEditors,
    control: props => ({
      key: 'TAG',
      type: 'component',
      component: (
        <TagComponent
          parentPrpos={props}
          insert={data => {
            insertTag(props.editor, props.editorState, data);
          }}
        />
      )
    }),
    mutability: 'IMMUTABLE',
    component: props => {
      const entity = props.contentState.getEntity(props.entityKey);
      const { selectType, text } = entity.getData();
      const activeType = textMap.find(val => selectType.indexOf(val.value) !== -1);
      const label = (activeType && activeType.label) || '';
      return (
        <Tooltip placement="top" title={<span>{`${label}： ${text}`}</span>}>
          <div style={{ display: 'inline-flex' }}>
            <div style={style}>
              <span style={styleTextOverflow}>{props.children}</span>
            </div>
            <span>&nbsp;</span>
          </div>
        </Tooltip>
      );
    },
    importer: (nodeName, node) => {
      if (nodeName.toLowerCase() === 'span' && node.classList && node.classList.contains('tag-wrap')) {
        // eslint-disable-next-line no-useless-escape
        const regxContent = /\{\{\s*replace\.(searchKeyWord|documentTitle)\s*(\|\s*\'(.*?)\'\s*)?\}\}/g;
        const content = node.innerText;
        let selectType = textMap[0].value;
        let text = '关键词';
        content.replace(regxContent, (...params) => {
          selectType = params[1];
          text = params[3];
        });
        return {
          mutability: 'IMMUTABLE',
          data: { selectType, text }
        };
      }
      return null;
    },
    exporter: entityObject => {
      const { selectType, text } = entityObject.data;
      return `<span className="tag-wrap">{{${selectType}|'${text}'}}</span>`;
    }
  };
};
